export const NOTIFICATION_TITLE = 'New chat message';
export const DEFAULT_BODY = 'You received a new chat message.';
export const SOUND_FREQUENCY_HZ = 880;
export const SOUND_DURATION_MS = 140;
export const SOUND_GAIN = 0.08;
export const SOUND_GAIN_MIN = 0.0001;
export const MS_PER_SECOND = 1_000;
